const triggerCustomGoogleAnalyticsEvent = require(".././googleAnalytics/triggerCustomGoogleAnalyticsEvent");

/**
 * @return {void}
 */
module.exports = function triggerRoiGateFormLastNameFieldGoogleAnalyticsEvent() {
    triggerCustomGoogleAnalyticsEvent("ROI_Form_LastName");
}